import { Pages } from "@constants/pages/Pages";
import { ModuleType } from "@enums/ModuleType";
import { GetIconByModuleString } from "@methods/Icons";
import { ApplicationPermissionsModel } from "@models/permissions/ApplicationPermissionsModel";
import { DashboardQuickLinkModel } from "../../../shared/models/DashboardQuickLinkModel";
import { ILinkWidgetGeneratorType } from "./../../../shared/interfaces/ILinkWidgetGeneratorType";

export class AuditLinkGenerator implements ILinkWidgetGeneratorType {
    getTypes(permissions: ApplicationPermissionsModel, pages: Pages): DashboardQuickLinkModel[] {
        const quickLinks = [];
        if (permissions.auditing.hasUniverseAccess) {
            quickLinks.push({
                title: "linkWidget.auditUniverseTitle",
                icon: GetIconByModuleString("audit universe"),
                page: pages.AuditUniverseOverview,

                description: "linkWidget.auditUniverseDescription",
            });
        }

        if (permissions.auditing.hasAuditAccess) {
            quickLinks.push({
                title: "linkWidget.auditOverviewTitle",
                icon: GetIconByModuleString(ModuleType.AUDITDescription),
                page: pages.AuditOverview,

                description: "linkWidget.auditOverviewDescription",
            });
        }

        if (permissions.auditing.hasPeriodAccess) {
            quickLinks.push({
                title: "linkWidget.auditPeriodsTitle",
                icon: "fad fa-calendar-day",
                page: pages.AuditUniversePeriod,

                description: "linkWidget.auditPeriodsDescription",
            });
        }

        if (permissions.auditing.hasFindingAccess) {
            quickLinks.push({
                title: "linkWidget.auditFindingsTitle",
                icon: "far fa-radar",
                page: pages.AuditFinding,

                description: "linkWidget.auditFindingsDescription",
            });
        }

        if (permissions.HasFindingReportAccess) {
            quickLinks.push({
                title: "linkWidget.findingReportTitle",
                icon: GetIconByModuleString(ModuleType.FRDescription),
                page: pages.ImOverview,

                description: "linkWidget.findingReportDescription",
            });
        }

        if (permissions.HasMoiAccess) {
            quickLinks.push({
                title: "linkWidget.moisTitle",
                icon: GetIconByModuleString(ModuleType.BIMDescription),
                page: pages.MoiOverview,

                description: "linkWidget.moisDescription",
            });
        }

        return quickLinks;
    }
}
